(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vuexy-vuejs-react-html-laravel-admin-dashboard-template-app"] = factory();
	else
		root["vuexy-vuejs-react-html-laravel-admin-dashboard-template-app"] = factory();
})(window, function() {
return 